import { render, staticRenderFns } from "./AddProduk.vue?vue&type=template&id=7502eddd&"
import script from "./AddProduk.vue?vue&type=script&lang=js&"
export * from "./AddProduk.vue?vue&type=script&lang=js&"
import style0 from "./AddProduk.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AddProduk.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports